import { BlogSizeEnum, type BlogSizeType } from './_size';
import { BlogVariantEnum, type BlogVariantType } from './_variants';

/**
 * Blog Themes
 */

import buttonDefaultStateTheme from '../_default';

import buttonBlogCommonTheme from './_common';

import buttonBlogVariantClassesMap from './variants';

export type ButtonBlogThemeArgs = {
  variant?: BlogVariantType;
  size?: BlogSizeType;
};

/**
 * Button Blog Theme
 */

const buttonBlogTheme = ({ variant = 'Primary', size = 'Medium' }: ButtonBlogThemeArgs) => {
  if (!BlogVariantEnum[variant]) return buttonDefaultStateTheme;

  const { buttonBlogClasses, buttonBlogTextClasses, buttonBlogSizeClassesMap, buttonBlogOnlyIconSizeClassesMap } =
    buttonBlogCommonTheme;

  const { buttonBlogVariantClasses, buttonIconClasses } = buttonBlogVariantClassesMap.get(
    BlogVariantEnum[variant],
  );

  const buttonThemeVariantClasses = buttonBlogVariantClasses.reduce((acc, curr) => acc.concat(' ', curr));
  const buttonThemeSizeClasses = buttonBlogSizeClassesMap.get(BlogSizeEnum[size]);
  const buttonThemeOnlyIconSizeClasses = buttonBlogOnlyIconSizeClassesMap.get(BlogSizeEnum[size]);

  return {
    buttonThemeClasses: buttonBlogClasses,
    buttonThemeTextClasses: buttonBlogTextClasses,
    buttonThemeIconClasses: buttonIconClasses,
    buttonThemeVariantClasses,
    buttonThemeSizeClasses,
    buttonThemeOnlyIconSizeClasses,
  };
};

export default buttonBlogTheme;
